import React, { useContext, useEffect, useCallback, useMemo } from 'react';
import { Context } from '../../store'
import './player.css';
import play_btn_img from '../../images/play-button.svg';
import pause_btn_img from '../../images/pause-button.svg';
import zaglushkaLogo from '../../images/zaglushka_logo.png';
import { getAlbumArt } from '../../services/albumArtService';
import DonateForm from './donate_form';
import PlaybackError from './PlaybackError';
import { isPlaybackActive } from '../../playback/createPlaybackController';

const PlayerWrapper = (_props) => {
  const [state, dispatch, playback] = useContext(Context);
  const playbackActive = isPlaybackActive(state.playbackStatus);

  const trackInfo = state.trackInfo ? state.trackInfo[state.stream] : null;
  const artist = trackInfo?.artist || 'Radio Myata';
  const track = trackInfo?.track || 'RADIO MYATA';
  const albumArts = useMemo(() => state.albumArts || {}, [state.albumArts]);

  // Update Media Session API for Lock Screen / Control Center
  const updateMediaSession = useCallback((artist, track, artworkUrl) => {
    if ('mediaSession' in navigator) {
      try {
        const defaultArt = window.location.origin + zaglushkaLogo;
        const finalArt = artworkUrl || defaultArt;

        const artwork = [
          { src: finalArt, sizes: '96x96', type: artworkUrl ? 'image/jpeg' : 'image/png' },
          { src: finalArt, sizes: '128x128', type: artworkUrl ? 'image/jpeg' : 'image/png' },
          { src: finalArt, sizes: '256x256', type: artworkUrl ? 'image/jpeg' : 'image/png' },
          { src: finalArt, sizes: '512x512', type: artworkUrl ? 'image/jpeg' : 'image/png' },
        ];

        navigator.mediaSession.metadata = new MediaMetadata({
          title: track && track !== 'Загрузка...' ? track : 'Radio Myata',
          artist: artist && artist !== 'Radio Myata' ? artist : 'Radio Myata',
          album: 'Radio Myata',
          artwork: artwork
        });

        // Set action handlers
        navigator.mediaSession.setActionHandler('play', () => playback.start());
        navigator.mediaSession.setActionHandler('pause', () => playback.stop());
        navigator.mediaSession.setActionHandler('stop', () => playback.stop());

        console.log('[MediaSession Desktop] Updated:', artist, '-', track);
      } catch (error) {
        console.warn('[MediaSession Desktop] Error:', error);
      }
    }
  }, [playback]);

  // Fetch album art when track changes
  useEffect(() => {
    const fetchArt = async () => {
      const currentInfo = state.trackInfo?.[state.stream];
      if (!currentInfo) return;

      const artistName = currentInfo.artist;
      const trackName = currentInfo.track;

      if (artistName && trackName && artistName !== 'Radio Myata' && artistName !== 'YOUR MUSIC! YOUR STATION!') {
        const cachedArt = albumArts[state.stream];
        if (cachedArt?.artist === artistName && cachedArt?.track === trackName) {
          updateMediaSession(artistName, trackName, cachedArt.url);
          return;
        }

        const art = await getAlbumArt(artistName, trackName);
        dispatch({
          albumArts: {
            ...albumArts,
            [state.stream]: { url: art, artist: artistName, track: trackName }
          }
        });
        updateMediaSession(artistName, trackName, art);
      } else {
        updateMediaSession('Radio Myata', 'Radio Myata', null);
      }
    };

    fetchArt();
  }, [state.trackInfo, state.stream, albumArts, updateMediaSession, dispatch]);

  const playRadio = () => playback.toggle();

  // const changeRadioVolume = () => {
  //   const volume_el = document.getElementById('volume-control');
  //   dispatch({ volume: volume_el.value / 100 });
  // }

  return (
    <div className='player-wrapper'>
      <DonateForm />
      <div className='player'>
        <div className='player-control'>
          <img
            onClick={playRadio}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                playRadio();
              }
            }}
            role='button'
            tabIndex={0}
            aria-label={playbackActive ? 'Остановить радио' : 'Включить радио'}
            aria-busy={state.isLoading}
            className='play-pause-button'
            src={playbackActive ? pause_btn_img : play_btn_img}
            alt='play button'
          />
        </div>
        <div className='track-info'>
          <span className='track-info-artist'>{artist}</span>
          <span className='track-info-title'>{track}</span>
          <PlaybackError status={state.playbackStatus} onRetry={playback.retry} />
        </div>
      </div>
    </div>
  )
}

export default PlayerWrapper;
